import BoardFundraisingResponseEditor from "./BoardFundraisingResponseEditor";
import { useState } from "react";
import { enterOperatorMode } from "@/operatorMode";
import { clearAdminPreview } from "@/adminPreview";

export default function BoardFundraisingCustomerControls({ client, customer, detail }) {
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const facilitated = (detail.payments || []).some(p => p.purchase_source === "board_fundraising_game_supported_2997" && p.payment_status === "paid");
  const assistance = (detail.payments || []).some(p => p.purchase_source === "board_fundraising_game_facilitation_997" && p.payment_status === "paid");
  const action = async (kind) => {
    setBusy(true); setError(""); setMessage("");
    try {
      const response = await client.post(`/admin/board-fundraising/customers/${encodeURIComponent(customer.user_id)}/${kind}`);
      if (kind === "workspace") {
        sessionStorage.removeItem("fundraisingPreparationToken"); sessionStorage.removeItem("fundraisingPreparationPath");
        clearAdminPreview();
        enterOperatorMode(response.data.user_id, customer.organization || customer.name, "Board Fundraising");
        window.location.assign(response.data.entry_route);
      } else setMessage(kind === "send-access" ? "Secure dashboard sign-in instructions sent." : "Customer dashboard access released. You can send the sign-in instructions when appropriate.");
    } catch (err) { setError(err.response?.data?.detail || "The action could not be completed."); }
    finally { setBusy(false); }
  };
  return <div className="bf-admin-live-panel">
    <h3>Customer dashboard access</h3>
    {assistance && <p>Action required: $997 Group Game facilitation assistance purchased. Work in this customer's existing dashboard.</p>}
    <button className="button button-small" disabled={busy} onClick={() => action("workspace")}>Open customer dashboard to assist</button>{" "}
    {facilitated && <>
      <button className="button button-small" disabled={busy} onClick={() => action("release-access")}>Release facilitated customer access</button>{" "}
      <button className="button button-small" disabled={busy} onClick={() => action("send-access")}>Send dashboard sign-in instructions</button>
    </>}
    <BoardFundraisingResponseEditor client={client} userId={customer.user_id}/>
    {message && <p role="status">{message}</p>}{error && <p role="alert" className="bf-admin-data-error">{error}</p>}
  </div>;
}
